
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import ItemDot from './ItemDot';

const classNames = mergeStyleSets({
    root: {
        paddingTop: 8
    }
});

const ResultBrief = ({items, showValidText}) => {
    return (items.length > 0)
        ? <Text color="#ff0000">Data obsahují chyby</Text>
        : (showValidText) 
            ? <Text>Data jsou v pořádku</Text>
            : null;
}

const ResultDetailed = ({items, showValidText}) => {
    return (items.length === 0)
        ? (showValidText) 
            ? <Text>Data jsou v pořádku</Text>
            : null
        : <Stack>
            {items.map((item, index) => {
                return (
                    <Text key={index} color="#ff0000"><ItemDot />{item}</Text>
                );
            })}
        </Stack>
}

const ObjectValidationResult = ({detailed, items, showValidText = true}) => {
    return (
        <Stack className={classNames.root}>
            {detailed
                ? <ResultDetailed items={items} showValidText={showValidText} />
                : <ResultBrief items={items} showValidText={showValidText} />
            }
        </Stack>
    )
}

export default ObjectValidationResult;
